import { DefaultTheme } from '../../components/theme';

export const CSS = {
	container: 'c-LineSymbolCustomizer',
	section: 'c-LineSymbolCustomizer__section',
	caption: 'c-LineSymbolCustomizer__caption',
	preview: 'c-LineSymbolCustomizer__preview',
	fixedMessage: 'c-LineSymbolCustomizer__fixedMessage',
	shapeGrid: 'c-LineSymbolCustomizer__shapeGrid',
	chip: 'c-LineSymbolCustomizer__chip',
	chipActive: 'c-LineSymbolCustomizer__chip--active',
	chipSwatch: 'c-LineSymbolCustomizer__chipSwatch',
	chipLabel: 'c-LineSymbolCustomizer__chipLabel',
};

export const PREVIEW_WIDTH = 256;
export const PREVIEW_HEIGHT = 24;

export const Style = {
	[CSS.container]: { display: 'flex', 'flex-direction': 'column', gap: DefaultTheme.space(4) },
	[CSS.section]: { display: 'flex', 'flex-direction': 'column', gap: DefaultTheme.space(2) },
	[CSS.caption]: {
		'font-size': '11px',
		'font-weight': 'bold',
		'letter-spacing': '0.5px',
		'text-transform': 'uppercase',
		color: DefaultTheme.font.color.supporting,
	},
	[CSS.preview]: {
		display: 'flex',
		'align-items': 'center',
		'justify-content': 'center',
		'min-height': '40px',
		padding: `${DefaultTheme.space(2)} ${DefaultTheme.space(3)}`,
		background: DefaultTheme.background.offWhite,
		border: `1px solid ${DefaultTheme.font.color.divider}`,
		'border-radius': '6px',
	},
	[CSS.fixedMessage]: {
		display: 'flex',
		'align-items': 'center',
		gap: DefaultTheme.space(2),
		'font-size': '12.5px',
		'line-height': 1.5,
		color: DefaultTheme.font.color.supporting,
	},
	[CSS.shapeGrid]: { display: 'grid', 'grid-template-columns': '1fr 1fr', gap: DefaultTheme.space(2) },
	[CSS.chip]: {
		display: 'flex',
		'flex-direction': 'column',
		'align-items': 'flex-start',
		gap: DefaultTheme.space(1),
		padding: `${DefaultTheme.space(2)} ${DefaultTheme.space(2)}`,
		cursor: 'pointer',
		'text-align': 'left',
		background: DefaultTheme.background.offWhite,
		border: `1.5px solid ${DefaultTheme.font.color.divider}`,
		'border-radius': '7px',
	},
	[`${CSS.chip}:hover`]: { background: DefaultTheme.background.lightGrey },
	[CSS.chipActive]: {
		'border-color': DefaultTheme.color.accent,
		background: DefaultTheme.background.lightGrey,
	},
	[CSS.chipSwatch]: { display: 'flex', 'align-items': 'center', height: '14px' },
	[CSS.chipLabel]: { 'font-size': '11.5px', color: DefaultTheme.font.color.supporting },
};
